export function cloudflareImageLoader({
  src,
  width,
  quality,
}: {
  src: string
  width: number
  quality?: number
}): string {
  const params = [`width=${encodeURIComponent(width)}`, 'format=webp']
  if (quality != null) {
    params.push(`quality=${encodeURIComponent(quality)}`)
  }
  const paramsString = params.join(',')
  return `https://assets.schoolhouse.world/cdn-cgi/image/${paramsString}/${src}`
}

export function isImageSupportedByLoader(src: string): boolean {
  return /\.(png|jpg|jpeg|gif|webp)$/.test(src)
}
